import React, { useEffect, useState } from "react";
import ClearingFundDetail from "../../components/ClearingFundDetail";
import Spinner from "components/Spinner";
import { displaySliceId } from "../../utils/sliceFormat";
import { RootState } from "StoreTypes";
import {
  fetchCFReportLoading,
  fetchCFReport,
  fetchMtmReport,
  fetchVarReport,
  fetchProjectedVarReport,
  fetchCFReportError,
} from "../../services/reports/selectors";
import { connect } from "react-redux";
import { CFItem, MtmItem, VarItem, DetailedError } from "../../types";
import styles from "./styles.module.scss";
import ClearingFundCharts from "../../components/ClearingFundCharts";
import { Checkbox } from "semantic-ui-react";

export interface Props {
  cfReport: CFItem;
  mtmReport: MtmItem;
  varReport: VarItem;
  projectedVarReport: VarItem;
  loading: boolean;
  error: DetailedError;
}

const CFReportViewer = ({
  cfReport,
  mtmReport,
  varReport,
  projectedVarReport,
  loading,
  error,
}: Props) => {
  const sliceID = cfReport.curSlice ? cfReport.curSlice.id : "";
  const [projected, setProjected] = useState(false);
  const [haveprojected, setHaveProjected] = useState(false);

  const handleToggle = () => {
    setProjected(!projected);
  };

  useEffect(() => {
    if (cfReport["apex-trend"]) {
      setHaveProjected(true);
    }
  }, [cfReport, setHaveProjected]);

  return (
    <div id="cf-viewer">
      <h1 className="cf-header">
        Clearing Fund Detail - {cfReport.curSlice ? cfReport.curSlice.date : ""}
        {" - "}
        {displaySliceId(sliceID)}
        <Checkbox
          className={styles.projectedSwitch}
          id="projected-cf-switch"
          label="Projected"
          disabled={!haveprojected}
          checked={projected}
          toggle
          onChange={handleToggle}
        />
      </h1>
      <Spinner loading={loading}>
        <div className={styles.container}>
          <ClearingFundDetail viewProjected={projected} cfReport={cfReport} />
          <div id="charts">
            <ClearingFundCharts
              cfTrend={cfReport.trend}
              projectedCfTrend={cfReport["apex-trend"]}
              mtmTrend={mtmReport.trend}
              varTrend={varReport.trend}
              projectedVarTrend={projectedVarReport.trend}
            />
          </div>
        </div>
      </Spinner>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  loading: fetchCFReportLoading(state),
  cfReport: fetchCFReport(state),
  mtmReport: fetchMtmReport(state),
  varReport: fetchVarReport(state),
  projectedVarReport: fetchProjectedVarReport(state),

  error: fetchCFReportError(state),
});
export default connect(mapStateToProps)(CFReportViewer);
